import type { Action } from '../App/types';
import * as ActionTypes from './constants';
import { GET_MONTHLY_TRANSACTIONS_SUCCESS } from '../ApplicationProfile/constants';

const initialState: any = {
  checklistStatus: undefined,
  screeningStatus: undefined,
  signedLeaseStatus: undefined,
  unitAvailabilityStatus: undefined,
};

const createCommercialTenantReducer = (
  state: any = initialState,
  action: Action<*>,
): any => {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.GET_ONE_APPLICATION_SUCCESS: {
      return { ...state, currentApplication: payload };
    }
    case ActionTypes.GET_APPLICATION_LEASE_STATUS_SUCCESS: {
      return { ...state, leaseStatus: payload };
    }
    case ActionTypes.GET_APPLICATION_INSURANCE_STATUS_SUCCESS: {
      return { ...state, insuranceStatus: payload };
    }
    case ActionTypes.GET_APPLICATION_CONTACT_STATUS_SUCCESS: {
      return { ...state, contactStatus: payload };
    }
    case ActionTypes.GET_APPLICATION_LEASE_START_DATE_STATUS_SUCCESS: {
      return { ...state, leaseStartDateStatus: payload };
    }
    case ActionTypes.GET_SIGNED_LEASE_STATUS_SUCCESS: {
      return { ...state, signedLeaseStatus: payload };
    }
    case ActionTypes.GET_UNIT_AVAILABILITY_STATUS_SUCCESS: {
      return { ...state, unitAvailabilityStatus: payload };
    }
    case ActionTypes.GET_ONE_APPLICATION_ERROR: {
      return { ...state, currentApplication: initialState.currentApplication };
    }
    case GET_MONTHLY_TRANSACTIONS_SUCCESS: {
      return {
        ...state,
        monthlyTransactions: payload,
      };
    }
    case ActionTypes.CLEAN: {
      return { ...initialState };
    }
    default:
      return state;
  }
};

export default createCommercialTenantReducer;
